<script>
  import InfoIcon from './svg/info_circle.svelte';
  import WarnIcon from './svg/warning_hex.svelte';

  export let lvl;

  const setLevel = () => {
    switch (lvl) {
    case 'debug':
      return { color: '#4ea4ff', component: InfoIcon };
    case 'info':
      return { color: '#4effcd', component: InfoIcon };
    case 'warn':
      return { color: 'yellow', component: WarnIcon };
    case 'error':
      return { color: '#ff1658', component: WarnIcon };
    case 'fatal':
      return { color: '#ff1658', component: WarnIcon };
    default:
      return { color: 'grey', component: InfoIcon };
    };
  }
  const icon = setLevel(lvl);
</script>

<div style='color: {icon.color};' title={lvl}>
  {#if icon?.component !== null}
    <svelte:component this={icon.component}/>
  {/if}
</div>

<style>
  div {
    text-transform: uppercase;
    font-size: 1rem;
    font-weight: 900;
  }
</style>
